module.exports = __webpack_public_path__ + "img/email_white.3e6cc74b.svg";